/**
 * Returns filtered list of carts that are non-empty.
 * NOTE: `/carts` API accepts `skip_empty` param to filter carts without cart_product
 *       This however, will filter out where cart_product.quantity = 0
 *
 * @param {Array} carts - list of cart objects
 * @return {Array} filteredCarts - list of non-empty carts
 */
export default function filterEmptyCarts(carts=[]) {
	return carts.filter((cart) => {
		// return cart.products quantity for this cart.
		// when it's empty it'll get filtered out
		return cart.products.reduce((qty, cp) => qty + cp.quantity, 0);
	});
}
